import { Suspense, useContext, useEffect, useState } from "react";
import { useParams } from "react-router";
import { FolderDocumentUpdate, moveFolderData } from "./DocumentService";
import { TostMsg } from "../../../App";
import ERROR_LIST from "../../../Services/Global-Services/Hadle_Errors";
import ComponentLoader from "../../../Shared/Sidebar/ComponentLoader";

const ErrorMessagePopup = ({ errorMessage, onCloseErrorPopup }) => {
  const [isLoading, setIsloading] = useState(false);
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const toster = useContext(TostMsg);

  useEffect(() => {
 
    if (errorMessage.Message) {
      const modalEl = document.getElementById("errorMessagePopup");
      const modal = new window.bootstrap.Modal(modalEl);
      modal.show();
    }
  }, [errorMessage]);

  async function DocumentFileReplace(IsOverrideValue) {
    const params = {
      Id: 0,
      LabelId: Number(errorMessage.FolderId),
      EmpId: userDetails?.EmpId,
      DocPath: errorMessage?.DocPath,
      Name: errorMessage.FileName,
      Desc: "",
      DocTypeId: errorMessage.DocTypeId,
      IsOverride: IsOverrideValue,
    };

    try {
      const response = await FolderDocumentUpdate(params);

      onCloseErrorPopup(true);
      document.querySelector("#errorMessagePopup .btn-close")?.click();

      setIsloading(false);
    } catch (error) {
      toster.current.error(ERROR_LIST.PostDocument);
      setIsloading(false);
    }
  }

  async function moveFolderReplace(IsOverrideValue) {
    let req = {
      OrgId: userDetails?.OrgId,
      LabelId: errorMessage.SelectedFolderId,
      Id: errorMessage.FolderId,

      IsOverride: IsOverrideValue,

      LoggedInUserId: userDetails?.Id,
    };
    try {
      const responseData = await moveFolderData(req);
      onCloseErrorPopup(true);
      document.querySelector("#errorMessagePopup .btn-close")?.click();
    } catch (error) {
      toster.current.error(error.Message);
    }
  }

  async function onFileReplace(IsOverrideValue) {
    if (errorMessage.SelectedFolderId > 0) {
        moveFolderReplace(IsOverrideValue);
    } else {
      DocumentFileReplace(IsOverrideValue);
    }
  }

  return (
    <div
      className="modal fade"
      id="errorMessagePopup"
      tabIndex="-1"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered modal-sm">
        <div className="modal-content p-0">
          <div className="modal-header">
            <h5 className="modal-title error-alert">Error Alert</h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              //   onClick={onCloseErrorPopup}
            ></button>
          </div>

          <div className="modal-body text-center">
            <p className="error-message">{errorMessage.Message}</p>

            <div className="text-center d-flex">
              <button
                type="button"
                className="cancelbtn-click"
                onClick={() => onFileReplace(1)}
              >
                Replace
              </button>

              <button
                type="button"
                className="savebtn-click btn-purple rounded"
                onClick={() => onFileReplace(2)}
              >
                Keep Both
              </button>
            </div>
          </div>
        </div>
      </div>

      {isLoading ? (
        <Suspense>
          <ComponentLoader />
        </Suspense>
      ) : (
        ""
      )}
    </div>
  );
};

export default ErrorMessagePopup;
